// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { query } from '@entries/entry-fragment'

export enum ContentType {
  ContentfulMultipleNumberHighlight = 'ContentfulNumbersHighlight',
  ContentfulNumberHighlight = 'ContentfulNumberHighlight',
  ContentfulRightLeftTextWithImage = 'ContentfulRightLeftTextWithImage',
  ContentfulAsset = 'ContentfulAsset',
  ContentfulAnimation = 'ContentfulAnimation',
  ContentfulAnimatedCard = 'ContentfulAnimatedCard',
  ContentfulBlogArticle = 'ContentfulBlogArticle',
  ContentfulBlogTag = 'ContentfulBlogTag',
  ContentfulBlogAuthor = 'ContentfulBlogAuthor',
  ContentfulInformationBanner = 'ContentfulInformationBanner',
  ContentfulContentArticle = 'Contentful4TmD9EihHakmKMkEwKaUwQ',
  ContentfulGraph = 'ContentfulGraphs',
  ContentfulConversionArea = 'ContentfulConversionArea',
  ContentfulCta = 'ContentfulCta',
  ContentfulDeprecatedPage = 'Contentful3TUjMz7TxKWiQYygwIysig',
  ContentfulEmbeddedAsset = 'ContentfulEmbeddedAsset',
  ContentfulFaqPage = 'ContentfulFaqPage',
  ContentfulFaqCategoryPage = 'ContentfulFaqCategoryPage',
  ContentfulFaqSubCategoryPage = 'ContentfulFaqSubCategoryPage',
  ContentfulFootnote = 'ContentfulFootnote',
  ContentfulForm = 'ContentfulLandingSouscriptionMarqueBlancheV2',
  ContentfulHighlightBlock = 'ContentfulHighlightBlock',
  ContentfulImage = 'ContentfulImage',
  ContentfulInformationPanel = 'ContentfulInformationPanel',
  ContentfulInternalLink = 'ContentfulInternalLink',
  ContentfulLandingPage = 'ContentfulLandingPage',
  ContentfulLink = 'ContentfulLink',
  ContentfulExternalLink = 'ContentfulExternalLink',
  ContentfulNavigationGroup = 'ContentfulNavigationGroup',
  ContentfulNavigationItem = 'ContentfulNavigationItem',
  ContentfulNumberedPunchline = 'ContentfulNumberedPunchline',
  ContentfulOfferDeprecated = 'Contentful10SSpX3YFi0CgK40EseM2G',
  ContentfulOffer = 'ContentfulOffer',
  ContentfulPartnerOffer = 'ContentfulPartnerOffer',
  ContentfulPdfLink = 'ContentfulPdfLink',
  ContentfulStaticPage = 'ContentfulStaticPage',
  ContentfulPageSection = 'ContentfulSection',
  ContentfulQuestionGroup = 'ContentfulQuestionGroup',
  ContentfulQuestion = 'ContentfulQuestion',
  ContentfulPlatformScore = 'ContentfulPlatformScore',
  ContentfulReview = 'Contentful4VKja7XjbWkW4WeI4OqeUi',
  ContentfulResponsiveImage = 'ContentfulResponsiveImage',
  ContentfulReassuranceArguments = 'ContentfulReassuranceArguments',
  ContentfulArgument = 'ContentfulArgument',
  ContentfulSeo = 'ContentfulSeo',
  ContentfulSite = 'ContentfulSite',
  ContentfulSpecialOffersPage = 'ContentfulSpecialOffersPage',
  ContentfulStaticBlock = 'ContentfulStaticBlock',
  ContentfulStepper = 'ContentfulStepper',
  ContentfulSubscriptionLink = 'ContentfulSubscriptionLink',
  ContentfulSubscriptionLinkWithLabel = 'ContentfulSubscriptionLinkWithLabel',
  ContentfulFaqPageList = 'ContentfulWrapperInbentaContentList',
  ContentfulWrapperRichMedia = 'ContentfulWrapperRichMedia',
  ContentfulYoutubePlayer = 'ContentfulPlayerYoutube',
  ContentfulShortContentBlock = 'ContentfulShortContentBlock',
  InbentaKmContent = 'InbentaKmContent',
  InbentaKmCategory = 'InbentaKmCategory',
  NetreviewsReview = 'NetreviewsReview',
  TrustpilotReview = 'TrustpilotReview',
  ContentfulBenefitsAndServices = 'ContentfulBenefitsAndServices',
  ContentfulCardOffer = 'ContentfulCardOffer',
  ContentfulOfferNumberedPunchline = 'ContentfulOfferNumberedPunchline',
}
